const isDefined = <T extends object>(input: null | undefined | T | string): input is T => {
  return input != null;
};

export default isDefined;
